/* @flow */
import React from 'react'
import styled from 'styled-components'
import DiscountBox from '../boxes/DiscountBox'
import { RegularRow } from '../utils/Grid'
import UTM from '../utils/UTM'
import WidgetContainer from '../containers/WidgetContainer'
import { type EcommerceWidgetProps } from './Types'

const WrapperRow = styled(RegularRow)`
  display: -ms-flexbox;
  -ms-flex-direction: row;
  -ms-flex-pack: justify;
  -ms-flex-wrap: wrap;
  justify-content: space-between;
`

export default (props: EcommerceWidgetProps) => {
  const {
    widget,
    widget: {
      boxes
    }
  } = props

  if (!boxes.length) {
    return null
  }

  return (
    <WidgetContainer widget={widget}>
      <WrapperRow>
        {
          boxes.map(box => {
            const {
              widget: {
                imageSize = '4_3',
                utmMedium,
                utmSource
              }
            } = props

            const {
              discount,
              guid,
              images,
              link,
              price,
              source,
              title
            } = box

            const utmParams = {
              utmCampaign: source,
              utmMedium,
              utmSource
            }

            const utmLink = new UTM(link).getUTMLink(utmParams, false)

            return <DiscountBox
              key={guid}
              discount={discount}
              guid={guid}
              image={images[imageSize]}
              imageClass={`image-${imageSize}`}
              link={utmLink}
              price={price}
              title={title}
            />
          })
        }
      </WrapperRow>
    </WidgetContainer>
  )
}
